module.exports = __webpack_public_path__ + "img/book-transfer-service.69238eed.svg";